import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import * as React from "react";
import { Button, getHeight } from "./Button";
import VisuallyHidden from "@reach/visually-hidden";
import PropTypes from "prop-types";
import { IconWrapper } from "./IconWrapper";
import { IconX } from "./Icons";
/**
 * A component which composes Button and Icon to provide
 * interactive icon elements.
 */

export var IconButton = React.forwardRef(function (_a, ref) {
  var label = _a.label,
      _b = _a.size,
      size = _b === void 0 ? "md" : _b,
      icon = _a.icon,
      children = _a.children,
      _c = _a.color,
      color = _c === void 0 ? "currentColor" : _c,
      other = tslib_1.__rest(_a, ["label", "size", "icon", "children", "color"]);

  return jsx(Button, tslib_1.__assign({
    ref: ref,
    size: size,
    css: {
      padding: 0,
      width: getHeight(size)
    }
  }, other), jsx(VisuallyHidden, null, label), jsx(IconWrapper, {
    color: "currentColor",
    size: size
  }, icon));
});
IconButton.displayName = "IconButton";
IconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["default", "ghost"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"])
};
export var CloseButton = function CloseButton(_a) {
  var _b = _a.label,
      label = _b === void 0 ? "Close" : _b,
      other = tslib_1.__rest(_a, ["label"]);

  return jsx(IconButton, tslib_1.__assign({
    variant: "ghost",
    label: label,
    icon: jsx(IconX, null)
  }, other));
};
CloseButton.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.oneOf(["default", "ghost"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"])
};